import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business メンバーレイアウト。配下ページごとにアクセス制御が異なる（members 一覧は VIEW_MEMBERS、
 *  idt-kpi は IDチーム看板の別ルール）ため、ガードは各葉ルート側に委譲し、ここは Outlet のみを描画する
 * @graph-connects none
 */
export const Route = createFileRoute('/members')({
  component: MembersLayout,
});

/** @graph-connects none */
function MembersLayout() {
  return <Outlet />;
}
